import request from '@/axios/request'

// 查询视频小节题目及弹题时间
export function getQuestionInfo(id) {
    return request({
        url: '/business/web/sqb/get/' + id,
        method: 'get',
    })
}
// 获取视频小节抓拍时间
export function getPtime(id) {
    return request({
        url: '/business/web/sqb/getPtime/' + id,
        method: 'get',
    })
}
